import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService } from 'src/modules/features/notification/services';
import { takeUntil, tap, map } from 'rxjs/operators';
import {
  SuiModalService,
  TransitionController,
} from '@richardlt/ng2-semantic-ui';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Notification, AppFilter } from '@app/shared';
import { environment } from 'src/environments/environment';
import { MediaObserver } from '@angular/flex-layout';
import { BannerMessageModal } from '../contractor/modals/banner-message-modal/banner-message-modal.component';
import { AnalyticsService } from 'src/modules/core/services';
import { UserService } from './services';

@Component({
  selector: 'app-public',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.scss'],
})
export class PublicComponent implements OnInit, OnDestroy {
  apps: Array<any> = [];
  baseUrl = environment.API_SERVER;
  currentHost = environment.currentHost;
  eServicesURL = environment.ESERVICES_URL;
  year = new Date().getFullYear();
  private unsubscribe$: Subject<void> = new Subject<void>();

  // transition controllers (router transition coming soon)
  public detailTransitionCtrl = new TransitionController();
  public createTransitionCtrl = new TransitionController();
  public listTransitionCtrl = new TransitionController();

  // this variables controls the visbilities of list and create option component (check template)
  public isCreate: boolean = false;
  public selected: boolean = true;

  public createLoading: boolean = false;
  public createSuccess: boolean = false;
  public createError: string = null;
  public optionPopulated: boolean;
  public notifications: Notification[];
  public notification: Notification;
  public contactUs: boolean;
  public detailUsed: boolean;
  contactDetails: any;
  loadingScroll: boolean;
  public maxSize = 5;

  public unRead: Notification[];
  public read: Notification[];

  public countUnread: number;

  read_status_false: any = false;

  //loading icon on clicking register.
  register() {
    this.loadingScroll = true;
  }

  searchParams: AppFilter;
  optionParams: AppFilter;
  filterType: AppFilter;
  loading: boolean;
  totalUnread: number = 0;

  filter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'read',
        op: 'eq',
        data: 'false',
      },
    ],
  };
  //our search control
  public search = new FormControl();
  config = {
    total: 0,
    page: 1,
    records: 0,
  };

  total: number = 0;
  page: number = 1;
  records: number = 0;

  searchFilter: string = '';
  organizationId: string;
  background: string;
  read_status: boolean;

  //initial option type
  notificationSearch: Notification = {
    read: false,
  };

  error: string | null;
  permissions: any[];
  user;
  photo;
  isLogin;
  isBanner: boolean;
  bannerMsg: any;
  bannerDesc: any;
  token: string = window.localStorage.getItem('token');
  constructor(
    public media: MediaObserver,
    private _searchsvc: NotificationService,
    private router: Router,
    private modalService: SuiModalService,
    private analyticsService: AnalyticsService,
    private userSvc: UserService
  ) {
    this.analyticsService.handleRouteEvents();
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.getBannerMsg();
    if (
      window.localStorage.getItem('jwt') &&
      this.user &&
      this.user['firstName']
    ) {
      this.isLogin = true;
    }
    if (this.user && this.user.image) {
      this.photo = `${
        this.eServicesURL
      }/api-server/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
    } else {
      this.photo = 'assets/avatar/1.jpg';
    }

    // initialize  search filter
    this.searchParams = new AppFilter({ sidx: 'dateCreated', rows: 5 });
    this.searchParams.filters = JSON.stringify(this.searchFilter);

    this.optionParams = new AppFilter({ sidx: 'dateCreated', rows: 5 });
    this.optionParams.filters = JSON.stringify(this.filter);

    this.loadingScroll = false;
  }
  triggerEvent() {
    this.userSvc.signinEvent.next(true);
  }
  getPage(page) {
    this.searchParams.page = page;
    this.loading = true;
    this._searchsvc
      .getNotifications({
        appUserId: this.organizationId,
        params: this.searchParams,
      })
      .pipe(
        tap((res) => {
          this.total = +res['records'];
          this.page = page;
          this.records = +this.searchParams.rows;
        }),
        map((res) => res['rows']),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (res: Notification[]) => {
          this.loading = false;
          this.notifications = res;
        },
        (error) => {
          this.loading = false;
          this.error = error;
        }
      );
  }
  showBanner() {
    this.modalService
      .open(new BannerMessageModal('Information', this.bannerMsg))
      .onApprove((eq) => {
        console.log('denied');
      })
      .onDeny((eq) => console.log('denied'));
  }

  getBannerMsg() {
    this._searchsvc.getPublicBannerMessage().subscribe(
      (res) => {
        this.isBanner = res['isAvailableToUser'];
        this.bannerMsg = res['appConfigValue'];
        this.bannerDesc = res['appConfigDescription'];
      },
      (error) => {
        this.error = error.message ? error.message : error;
      }
    );
  }

  getUnreadPage(page) {
    this.loading = true;
    this._searchsvc
      .getNotifications({
        appUserId: this.organizationId,
        params: this.optionParams,
      })
      .pipe(
        tap((res) => {
          this.totalUnread = +res['records'];
          this.page = page;
          this.records = +this.optionParams.rows;
        }),
        map((res) => res['rows']),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (res: Notification[]) => {
          this.loading = false;
          this.unRead = res;
          this.checkOptionList(this.unRead);
        },
        (error) => {
          this.loading = false;
          this.error = error;
        }
      );
  }

  checkOptionList(value: Notification[]) {
    if (value != null && value.length > 0) {
      this.optionPopulated = true;
    } else {
      this.optionPopulated = false;
    }
  }

  ngOnDestroy() {
    // unsubscribe all subsciptons
    document.getElementsByTagName('body')[0].style.fontFamily =
      'Roboto, "Helvetica Neue", Arial, Helvetica, sans-serif';
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  logout() {
    localStorage.clear();
    this.router.navigate(['/home-page']);
  }
  ngOnInit(): void {
    document.getElementsByTagName('body')[0].style.fontFamily = 'Montserrat';
  }
}
